const PUBLICO_ALVO = {
    GERAL: { id: 'G', descricao: 'Geral' },
    QUALIFICADO: { id: 'Q', descricao: 'Investidor Qualificado' },
    PROFISSIONAL: { id: 'P', descricao: 'Investiror Profissional' },
    PREVIDENCIARIO: { id: 'P', descricao: 'Previdenciário' }
};

module.exports = PUBLICO_ALVO;
